import React from 'react';
import Button from './ui/Button';
import Icon from './AppIcon';


const EmptyState = ({ 
  icon: Icon, 
  title, 
  description, 
  primaryAction, 
  secondaryAction,
  className = "" 
}) => {
  return (
    <div className={`text-center py-12 px-4 ${className}`}>
      <div className="mx-auto max-w-md">
        {Icon && (
          <div className="mx-auto h-12 w-12 text-gray-400 mb-4">
            <Icon className="h-full w-full" />
          </div>
        )}
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          {title}
        </h3>
        <p className="text-sm text-gray-500 mb-6">
          {description}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {primaryAction && (
            <Button
              onClick={primaryAction?.onClick}
              className="inline-flex items-center"
            >
              {primaryAction?.icon && (
                <primaryAction.icon className="h-4 w-4 mr-2" />
              )}
              {primaryAction?.label}
            </Button>
          )}
          {secondaryAction && (
            <Button
              variant="outline"
              onClick={secondaryAction?.onClick}
              className="inline-flex items-center"
            >
              {secondaryAction?.icon && (
                <secondaryAction.icon className="h-4 w-4 mr-2" />
              )}
              {secondaryAction?.label}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmptyState;